import { render, staticRenderFns } from "./shopList.vue?vue&type=template&id=742290c2&scoped=true"
import script from "./shopList.vue?vue&type=script&lang=js"
export * from "./shopList.vue?vue&type=script&lang=js"
import style0 from "./shopList.vue?vue&type=style&index=0&id=742290c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "742290c2",
  null
  
)

export default component.exports